module.exports = __webpack_public_path__ + "img/5.5b7cd72e.png";